import imgProcess from "../../../assets/img/img-process.svg";
import { ImageBand } from "../../common/components/ImageComponents/ImageBand";
import noImage from "../../../assets/img/no-image-available.png";
import ReactTooltip from "react-tooltip";

const RenderImageBand = ({
    noView,
    imageLoaded,
    selectedImage,
    imageList,
    zoomInRef,
    zoomOutRef,
    resetRef,
    viewImageHandler,
    setShowAdditionalButtons,
    getSurveyAssetImagesById,
    showAdditionalButtons,
    updateImage = () => null
}) => (
    <div className="img-view cursor-hand">
        {imageLoaded && selectedImage ? (
            <div class="col-md-12 back-set image-band-otr">
                <div className="details-img-block details-img-new col-md-12 asset-detail-imgview">
                    <ImageBand
                        basicDetails={{}}
                        // deleteImage={deleteImage}
                        getAllImagesResponse={imageList}
                        refreshImageList={() => {}}
                        isImagePreview={true}
                        updateImage={updateImage}
                        onZoomIn={zoomInFunc => {
                            zoomInRef.current = zoomInFunc;
                        }}
                        onZoomOut={zoomOutFunc => {
                            zoomOutRef.current = zoomOutFunc;
                        }}
                        onReset={resetFunc => {
                            resetRef.current = resetFunc;
                        }}
                        onViewImage={handler => {
                            viewImageHandler.current = handler;
                        }}
                        isZoom={value => setShowAdditionalButtons(value)}
                        isSurveyAssetView
                        hasEdit={false}
                        isModalView={noView}
                        key={noView ? "modal" : "band"}
                        hasCaptionEdit={false}
                    />
                </div>
            </div>
        ) : (
            <div className="image-preview">
                <div class="img-process-otr">
                    {!imageLoaded &&
                    [...(getSurveyAssetImagesById?.data?.image ?? []), ...(getSurveyAssetImagesById?.data?.added_image ?? [])].length ? (
                        <>
                            <img src={imgProcess} />
                            <h3>Processing...</h3>
                        </>
                    ) : (
                        <>
                            <img className="no-mobile-image" src={noImage} alt="" />
                        </>
                    )}
                </div>
            </div>
        )}
        {imageLoaded && selectedImage && (
            <div className="mob-asset md-grp-btn asset-img-grp ">
                {!noView && (
                    <button
                        type="button"
                        onClick={() => {
                            if (viewImageHandler.current) {
                                viewImageHandler.current();
                            }
                        }}
                        data-tip="View"
                        data-for="image_icons"
                    >
                        <i class="far fa-eye"></i>
                    </button>
                )}
                <button
                    type="button"
                    onClick={e => {
                        zoomInRef?.current && zoomInRef?.current(e);
                    }}
                    data-tip="Zoom In"
                    data-for="image_icons"
                >
                    <img src="/img/zoom-in.svg" alt="Zoom In" />
                </button>
                <button
                    type="button"
                    onClick={e => {
                        zoomOutRef?.current && zoomOutRef?.current(e);
                    }}
                    data-tip="Zoom Out"
                    data-for="image_icons"
                >
                    <img src="/img/zoom-out.svg" alt="Zoom Out" />
                </button>
                <button
                    type="button"
                    className={`${showAdditionalButtons ? "hand-cursor" : "cursor-disabled"}`}
                    disabled={!showAdditionalButtons}
                    onClick={e => {
                        resetRef?.current && resetRef?.current(e);
                    }}
                    data-tip="Reset"
                    data-for="image_icons"
                >
                    <i className="fas fa-sync image-icons"></i>
                </button>

                <ReactTooltip id="image_icons" effect="solid" className="rc-tooltip-custom-class" backgroundColor="#007bff" place="left" />
            </div>
        )}
    </div>
);

export default RenderImageBand;
